import React from 'react';
import { ASSOCIAZIONE_MASSIVA_STATUS_TYPES } from '../Resources/objects';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { GET_ONE, GET_MANY } from 'react-admin';
import DoneIcon from '@mui/icons-material/Done';
import { FUNCTION_URL } from '../Constants';
import jsonServerProvider from '../jsonProvider/digigemJsonProvider';

const dataProvider = jsonServerProvider(FUNCTION_URL);

export const validateNonAlphanumeric = (value) => {
  let findNonAlphanumeric = new RegExp(/[^a-z0-9]/gi);
  return !findNonAlphanumeric.test(value);
}

export const getDevicesByNMUInAttribuito = async (NMUs, isScaricoMultiplo) => {
  let options = {
    "filter": {
      'cod_nmu': { '$in': NMUs },
      'status.codice': { '$in': ['1', '6'] },
    }
  };
  if (isScaricoMultiplo) options.filter.isScaricoMultiplo = true;

  return await dataProvider(GET_MANY, 'devices', options)
    .then(response => response.data)
}

export const checkDeviceCountPerTaskNMUs = (NMUQuantities, showMessage) => {
  let isCountValid = true;

  Object.entries(NMUQuantities).forEach(nmu => {
    if (nmu[1].quantity < nmu[1].selected) {
      if (showMessage) showMessage("La WR ha raggiunto la quantità massima di associazioni", 'error');
      isCountValid = false;
    } else if (nmu[1].quantity > nmu[1].selected) {
      if (showMessage) showMessage("Quantità non coerenti con quanto indicato nella WR: NMU=" + nmu[1].values.toString() + " con quantità=" + nmu[1].quantity + ", trovato=" + nmu[1].selected, 'error');
      isCountValid = false;
    }
  })

  return isCountValid;
}

/**
 * Returns an array of devices
 */
export const getDevicesById = async (array) => {
  const dataProvider = jsonServerProvider(FUNCTION_URL);
  let fetchDevicePromiseArray = [];
  for (let index = 0; index < array.length; index++) {
    fetchDevicePromiseArray.push(new Promise((resolve, reject) => {
      dataProvider(GET_ONE, 'devices', { id: array[index] })
        .then(response => resolve(response.data))
        .catch(error => {
          reject(error);
        })
    }));
  }
  return await Promise.all(fetchDevicePromiseArray);
};

/**
 * Returns a task
 */
export const getTaskById = (workrequestid) => {
  try {
    return dataProvider(GET_ONE, 'tasks', { workrequestid: workrequestid })
      .then(response => {
        console.log("response");
        return response.data
      })
  }
  catch (error) {
    console.error(error);
    return error;
  }
}

export const getStatusIcon = (status) => {
  switch (status) {
    case ASSOCIAZIONE_MASSIVA_STATUS_TYPES['ERROR']:
      return <ErrorIcon color="error" />
    case ASSOCIAZIONE_MASSIVA_STATUS_TYPES['WARNING']:
      return <WarningIcon color="error" />
    case ASSOCIAZIONE_MASSIVA_STATUS_TYPES['SUCCESS']:
      return <DoneIcon color="success" />
    default:
      return;
  }
}
